import { render, staticRenderFns } from "./WardInformation.vue?vue&type=template&id=3ac7e2d2&"
import script from "./WardInformation.vue?vue&type=script&lang=js&"
export * from "./WardInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports